export default __webpack_public_path__ + "static/media/teachers_profile_pic.b87b540f.png";